import oidcStore from '../../stores/oidcStore';
import usersStore from '../../stores/usersStore';
import permissionsStore from '../../stores/permissions';
import configurationsStore from '../../stores/configurationsStore';
import Permissions from '../enums/permissions';

class RolesChackboxListFilter {

    async filterRoles(roleList, currentUserRolesIds, userId) {
        let isAdmin = await usersStore.isCurrentUserAdmin();
        let isAssignAllRolesByManageUsersEnabled = configurationsStore.isAssignAllRolesByManageUsersEnabled;
        if(isAdmin){
            return roleList;
        }else if(isAssignAllRolesByManageUsersEnabled){
            if(oidcStore.currentUser.profile.sub == userId){
                return roleList.filter(r => currentUserRolesIds.includes(r.id));
            }
            const manageUsersId = await permissionsStore.getPermissionIdByName(Permissions.manageUsers);
            return roleList.filter(r => !r.permissionIds.includes(manageUsersId) || currentUserRolesIds.includes(r.id));
        }
        this.userPermissions = this.getUserPermissions(roleList);
        return roleList.filter(r => this.isCurrentUserHasSufficentPermissions(r.permissionIds) || currentUserRolesIds.includes(r.id));
    };

    async filterBulkRoles(roleList){
        let isAdmin = await usersStore.isCurrentUserAdmin();
        let isAssignAllRolesByManageUsersEnabled = configurationsStore.isAssignAllRolesByManageUsersEnabled;
        if(isAdmin){
            return roleList;
        }else if(isAssignAllRolesByManageUsersEnabled){
            const manageUsersId = await permissionsStore.getPermissionIdByName(Permissions.manageUsers);
            return roleList.filter(r => !r.permissionIds.includes(manageUsersId));
        }
        this.userPermissions = this.getUserPermissions(roleList);
        return roleList.filter(r => this.isCurrentUserHasSufficentPermissions(r.permissionIds));
    }

    getUserPermissions(roleList) {
        var currentUser =  usersStore.users.filter((u)=> u.id == oidcStore.currentUser.profile.sub)[0];       
        const currentUserRoles = roleList.filter(r => currentUser.roleIds.includes(r.id));
        var currentUserPermissions = [];

        currentUserRoles.forEach((x) => {
            x.permissionIds.forEach((p) => {
                currentUserPermissions.push(p);    
            });
        });

        return [...new Set(currentUserPermissions)];
    };

    isCurrentUserHasSufficentPermissions(rolePermissions) {
        return rolePermissions.every((value) => {
            return (this.userPermissions.indexOf(value) >= 0);
        });
    }
}

export default new RolesChackboxListFilter();